import React from 'react';
import { Box } from '@chakra-ui/react';
import { CurrencyDollar, Receipt, Scroll, Ticket } from 'phosphor-react';
import { PiIntersectSquareDuotone, PiRobotDuotone, PiWhatsappLogoDuotone } from 'react-icons/pi';
import { RiFileList3Line } from 'react-icons/ri';
import { FiDivideSquare } from 'react-icons/fi';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { AuditoriaInteligenteIcon } from '../icons/AuditoriaInteligenteIcon';

export interface IModuloSidebar {
  name: string;
  path: string;
  codigo?: string;
  icon: React.ReactNode;
  /** Fundo do ícone (cor do módulo). */
  bgColor: string;
  /** Drill-only: destino do "Voltar" e texto ao lado dele. */
  backPath?: string;
  backLabel?: string;
}

// Lista única dos módulos do menu lateral e do menu mobile (antes o mobile
// tinha uma cópia desatualizada, sem Societário, Eventos, Financeiro...).
export const MODULOS_SIDEBAR: IModuloSidebar[] = [
  {
    name: 'Chat',
    path: '/chatPro',
    codigo: 'chat-pro',
    icon: <PiRobotDuotone color="#ad47ac" className="size-5" />,
    bgColor: '#f0ddee',
  },
  {
    name: 'WhatsApp',
    path: '/whatsapp',
    codigo: 'whatsapp-chat',
    icon: <PiWhatsappLogoDuotone color="#25D366" className="size-5" />,
    bgColor: '#d4f5e0',
  },
  {
    name: 'Societário',
    path: '/societario',
    codigo: 'societario',
    icon: <Scroll color="#B45309" weight="duotone" className="size-5" />,
    bgColor: '#FEF3C7',
  },
  {
    name: 'Eventos',
    path: '/eventos',
    codigo: 'eventos',
    icon: <Ticket color="#E65100" className="size-5" />,
    bgColor: '#FFF3E0',
  },
  {
    name: 'Integração',
    path: '/modulesHome/integration',
    codigo: 'integracao-dashboard',
    icon: <PiIntersectSquareDuotone color="#0A4E70" className="size-5" />,
    bgColor: '#CFEFFF',
  },
  {
    name: 'Fiscal',
    path: '/modulesHome/supervisor',
    codigo: 'supervisor-dashboard',
    icon: <RiFileList3Line color="#008CCC" className="size-5" />,
    bgColor: '#DFF3FF',
  },
  {
    name: 'Contábil',
    path: '/modulesHome/accountingConciliation',
    codigo: 'conciliacao-contabil-dashboard',
    icon: <FiDivideSquare color="#F2994A" className="size-5" />,
    bgColor: '#FFE1C6',
  },
  {
    name: 'Departamento Pessoal',
    path: '/modulesHome/personnelDepartment',
    codigo: 'dp-dashboard',
    icon: <IoDocumentTextOutline color="#219653" className="size-5" />,
    bgColor: '#D5F5E3',
  },
  {
    name: 'Financeiro',
    path: '/modulesHome/financeiro',
    codigo: 'financeiro-dashboard-hub',
    icon: <CurrencyDollar color="#FF8A00" weight="duotone" className="size-5" />,
    bgColor: '#FFE9D5',
  },
  {
    name: 'Auditoria Inteligente',
    path: '/modulesHome/auditoria-inteligente',
    codigo: 'auditoria-inteligente',
    icon: <AuditoriaInteligenteIcon variant="glyph" size={20} />,
    bgColor: '#EDE9FE',
  },
];

// Módulos com menu próprio que não aparecem na lista raiz: entram por outro
// módulo (a Emissão de NFS-e fica dentro do Fiscal) e o "Voltar" leva de volta.
export const MODULOS_SO_DRILL: IModuloSidebar[] = [
  {
    name: 'Emissão de NFS-e',
    path: '/modulesHome/supervisor/nfse-emissao',
    icon: <Receipt color="#008CCC" className="size-5" />,
    bgColor: '#DFF3FF',
    backPath: '/modulesHome/supervisor',
    backLabel: 'Fiscal',
  },
];

export const isModuloAtivo = (path: string, pathname: string): boolean =>
  pathname === path || pathname.startsWith(`${path}/`);

/** Ícone do módulo num quadrado arredondado com a cor dele. */
export const ModuloTile = ({ modulo, ativo }: { modulo: IModuloSidebar; ativo?: boolean }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    w="36px"
    h="36px"
    borderRadius="12px"
    bg={modulo.bgColor}
    boxShadow={
      ativo
        ? '0 0 0 2px #FFFFFF, 0 0 0 3.5px rgba(27,136,245,0.55)'
        : 'inset 0 0 0 1px rgba(15,23,42,0.04)'
    }
    transition="box-shadow 0.18s ease"
  >
    {modulo.icon}
  </Box>
);
